import { render, staticRenderFns } from "./AllocationServices.vue?vue&type=template&id=6380c570&scoped=true"
import script from "./AllocationServices.vue?vue&type=script&lang=js"
export * from "./AllocationServices.vue?vue&type=script&lang=js"
import style0 from "./AllocationServices.vue?vue&type=style&index=0&id=6380c570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6380c570",
  null
  
)

export default component.exports